import { Box, Card, Divider } from "@origin-digital/ods-core";
import { IconSearch } from "@origin-digital/ods-icons";
import { Skeleton } from "@origin-digital/ods-lab";

const CantFindRow = ({
  dataId,
  textWidth,
}: {
  dataId: string;
  textWidth: string;
}): JSX.Element => (
  <Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    gap="small"
    data-id={dataId}
    paddingY="small"
  >
    <IconSearch color="secondaryB" size="xsmall" />
    <Box width="full">
      <Skeleton variant="text" width={textWidth} backgroundColor="light" />
    </Box>
  </Box>
);

export const CantFindSkeleton = (): JSX.Element => (
  <Box
    outline
    data-id="cant-find-skeleton"
    padding="large"
    borderRadius="medium"
    marginTop="medium"
  >
    <Box marginBottom="small">
      <Skeleton variant="text" width="100%" backgroundColor="light" />
    </Box>

    <CantFindRow dataId="cant-find-skeleton-row-1" textWidth="50%" />
    <Divider />
    <CantFindRow dataId="cant-find-skeleton-row-2" textWidth="60%" />
    <Divider />
    <CantFindRow dataId="cant-find-skeleton-row-3" textWidth="70%" />
    <Divider />
  </Box>
);
